<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { IsPC } from "./utils/auth.js";
export default {
  name: "App",
  mounted() {
    if (IsPC()) {
    } else {
      window.location.href = "./mb/index.html";
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue